// middleware/redirectIfLoggedIn.ts
// À appliquer sur les routes publiques (ex. home) : si déjà connecté, évite la landing
// et renvoie vers /discuter (même logique que post-login).

import { DEFAULT_LOGGED_IN_PATH, resolvePostLoginRoute } from '~/utils/postLoginRedirect'

export default defineNuxtRouteMiddleware(async () => {
  const userStore = useUserStore()
  if (!userStore.isLoggedIn) return

  const path: string = await resolvePostLoginRoute(DEFAULT_LOGGED_IN_PATH)
  return navigateTo(path)
})
